import apiService from "@/api-service";
import HeaderedContainer from "@/components/headered-container/headered-container";
import { useEffect, useState } from "react";
import { ResponsiveContainer, Tooltip, PieChart, Pie, Label, Cell, Legend } from "recharts";

const PIE_COLORS = ['#009de0', '#0077b6', '#48cae4', '#0096c7', '#023e8a', '#00b4d8', '#90e0ef', '#caf0f8'];

export default function FrequentBestekkenByKeyChart(props: { title: string, field: string, type: 'sankey' | 'pie', className?: string, card?: boolean }) {
    const [frequentBestekken, setFrequentBestekken] = useState<{ [key: string]: any, bestekken_count: number }[] | null>(null);

    const fetch = (): void => {
        apiService.post('stats/frequent-bestekken-by-key', { 'key': props.field })
            .then((response) => {
                setFrequentBestekken(response.data);
            }, console.error);
    };

    useEffect(() => {
        if (frequentBestekken === null) {
            fetch();
        }
    });

    const total = frequentBestekken?.reduce((v, b) => v + b.bestekken_count, 0) ?? 0;

    return (
        <HeaderedContainer title={props.title} className={props.className} card={props.card}>
            {frequentBestekken && props.type === 'pie' && (
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={frequentBestekken}
                            dataKey="bestekken_count"
                            nameKey={props.field}
                            cx="50%"
                            cy="50%"
                            innerRadius="45%"
                            outerRadius="65%"
                            paddingAngle={2}
                            labelLine={false}
                        >
                            {frequentBestekken.map((_, i) => (
                                <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
                            ))}
                            <Label
                                value={total.toLocaleString('nl-NL')}
                                position="center"
                                style={{ fontSize: 22, fontWeight: 700, fill: '#1a1a2e' }}
                            />
                        </Pie>
                        <Tooltip formatter={(value: any) => [value.toLocaleString('nl-NL'), 'Bestekken']} />
                        <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, color: '#666' }} />
                    </PieChart>
                </ResponsiveContainer>
            )}
        </HeaderedContainer>
    );
}
